import _taggedTemplateLiteral from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _objectSpread from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _defineProperty from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject;
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { ICON_DEFAULT_HOST, settings } from '@polkadot/ui-settings';
import { isHex, isU8a, u8aToHex } from '@polkadot/util';
import { decodeAddress, encodeAddress, ethereumEncode } from '@polkadot/util-crypto';
import { Beachball, Empty, Ethereum, Jdenticon, Polkadot } from './icons/index.js';
import { styled } from './styled.js';
const Fallback = Beachball;
const DEFAULT_SIZE = 64;
const Components = {
  beachball: Beachball,
  empty: Empty,
  ethereum: Ethereum,
  jdenticon: Jdenticon,
  polkadot: Polkadot,
  substrate: Jdenticon
};
class BaseIcon extends React.PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      address: '',
      publicKey: '0x'
    });
    _defineProperty(this, "onCopy", () => {
      const {
        onCopy
      } = this.props;
      const {
        address
      } = this.state;
      if (address && onCopy) {
        onCopy(address);
      }
    });
  }
  static setDefaultPrefix(prefix) {
    BaseIcon.prefix = prefix;
  }
  static getDerivedStateFromProps(_ref, prevState) {
    let {
      prefix = BaseIcon.prefix,
      theme,
      value
    } = _ref;
    if (theme === 'ethereum') {
      const address = isU8a(value) ? ethereumEncode(value) : value || '';
      return {
        address,
        publicKey: ''
      };
    }
    try {
      const address = isU8a(value) || isHex(value) ? encodeAddress(value, prefix) : value || '';
      const publicKey = u8aToHex(decodeAddress(address, false, prefix));
      return address === prevState.address ? null : {
        address,
        publicKey
      };
    } catch (_unused) {
      return {
        address: '',
        publicKey: '0x'
      };
    }
  }
  render() {
    const {
      address
    } = this.state;
    const wrapped = this.getWrapped(this.state, this.props);
    return !address ? wrapped : _jsx(CopyToClipboard, {
      onCopy: this.onCopy,
      text: address,
      children: wrapped
    });
  }
  getWrapped(_ref2, _ref3) {
    let {
      address,
      publicKey
    } = _ref2;
    let {
      Custom
    } = _ref3;
    const {
      className = '',
      isAlternative,
      isHighlight,
      size = DEFAULT_SIZE,
      style = {},
      theme = settings.icon
    } = this.props;
    const Component = !address ? Empty : Custom || Components[theme === 'default' ? ICON_DEFAULT_HOST : theme] || Fallback;
    return _jsx(StyledDiv, {
      className: "ui--IdentityIcon  ".concat(className),
      style: style,
      children: _jsx(Component, {
        address: address,
        className: isHighlight ? 'highlight' : '',
        isAlternative: isAlternative,
        publicKey: publicKey,
        size: size
      })
    }, address);
  }
}
_defineProperty(BaseIcon, "prefix", undefined);
function Icon(props) {
  return _jsx(BaseIcon, _objectSpread({}, props));
}
const StyledDiv = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: copy;\n  display: inline-block;\n  line-height: 0;\n\n  > .container {\n    position: relative;\n\n    > div,\n    > svg {\n      position: relative;\n    }\n\n    &.highlight:before {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      border-radius: 50%;\n      box-shadow: 0 0 5px 2px #aaa;\n      content: '';\n    }\n  }\n"])));
export const Identicon = React.memo(Icon);